import axios from "axios";
import { get } from "lodash";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_PRODUCT_DETAILS: "applications/FETCH_PRODUCT_DETAILS",
  SAVE_PRODUCT_DETAILS: "applications/SAVE_PRODUCT_DETAILS",
};

const initialState = {
  loading: false,
  productDetails: null,
};

export type ApplicationProductState = Readonly<typeof initialState>;

const parseProductDetails = productDetails => {
  return {
    ...productDetails,
    monthlyBenefit: get(productDetails, "monthlyBenefit") || 0,
    catAmount: get(productDetails, "catAmount") || 0,
    fioAmount: get(productDetails, "fioAmount") || 0,
    blpAmount: get(productDetails, "blpAmount") || 0,
    studentAmount: get(productDetails, "studentAmount") || 0,
    otherAmount: get(productDetails, "otherAmount") || 0,
    income: get(productDetails, "income") || 0,
  };
};

/**
 * ApplicationProduct Reducer
 */
export default (state: ApplicationProductState = initialState, action): ApplicationProductState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_PRODUCT_DETAILS):
    case PENDING(ACTION_TYPES.SAVE_PRODUCT_DETAILS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_PRODUCT_DETAILS):
      return { ...state, loading: false, productDetails: parseProductDetails(action.payload.data) };

    case FULFILLED(ACTION_TYPES.SAVE_PRODUCT_DETAILS):
      return { ...state, loading: false };

    case REJECTED(ACTION_TYPES.FETCH_PRODUCT_DETAILS):

    case REJECTED(ACTION_TYPES.SAVE_PRODUCT_DETAILS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Actions for fetching Product details data
 */

export const fetchProductDetails = (applicationId: string) => ({
  type: ACTION_TYPES.FETCH_PRODUCT_DETAILS,
  meta: { applicationId },
  payload: axios.get(`/applications/${applicationId}/productDetails`),
});

/**
 * Action to save or update Product details
 */
export const saveProductDetails = (applicationId, productData) => ({
  type: ACTION_TYPES.SAVE_PRODUCT_DETAILS,
  payload: axios.post(`/applications/${applicationId}/productDetails`, productData, {
    headers: { "Content-Type": "application/json" },
  }),
});
